export const CONTACT_PHONE = "8179886658";
export const CONTACT_PHONE_DISPLAY = "+91 8179886658";
export const CONTACT_PHONE_TEL = "+918179886658";
export const CONTACT_EMAIL = "info@confideoit.com";
export const CONTACT_LOCATION = "Hyderabad, India";

/** WhatsApp wa.me link — country code 91, no + or spaces */
export const WHATSAPP_NUMBER = "918179886658";
export const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}`;

export const SOCIAL_LINKS = {
  whatsapp: WHATSAPP_URL,
  instagram: "https://www.instagram.com/confideoit/",
  youtube: "https://www.youtube.com/@confideocloudcode",
  linkedin: "https://www.linkedin.com/company/confideo-it-services/",
};

export function buildWhatsAppMessage({ name, email, phone, course, message }) {
  return [
    "New enquiry from Confideo Cloud & Code website",
    "",
    `Name: ${name}`,
    `Email: ${email}`,
    `Phone: ${phone}`,
    `Interested Course: ${course || "Not specified"}`,
    "",
    "Message:",
    message,
  ].join("\n");
}

export function openWhatsAppChat(text) {
  const url = `${WHATSAPP_URL}?text=${encodeURIComponent(text)}`;
  window.open(url, "_blank", "noopener,noreferrer");
}
